module.exports = __webpack_public_path__ + "static/media/refer-a-friend.15c48938.jpeg";